import { Component, OnInit, Input } from "@angular/core";

import * as _ from "lodash";

@Component({
  selector: "sort-filter-images",
  templateUrl: "./sort-filter-images.component.html",
  styleUrls: ["./sort-filter-images.component.scss"],
})
export class SortFilterImagesComponent implements OnInit {
  @Input() column;
  @Input() sortColumns;
  @Input() filterColumns;
  @Input() status;
  @Input() i;

  constructor() {}

  ngOnInit() {}

  currentlyFilteredOrSorted(column) {
    if (this.sortColumns || this.filterColumns) {
      return (
        _.find(this.sortColumns, (sortCol) => {
          return sortCol.student_kpi_id == column.id;
        }) ||
        _.find(this.filterColumns, (filterCol) => {
          return filterCol.student_kpi_id == column.id;
        })
      );
    } else {
      return false;
    }
  }
}
